"use client"
import React, {FC, useEffect, useState} from 'react';
import {WidgetProps} from './component/widgetTitleBar';
import {WidgetContainerComponent} from "@/core/general/ui/widgetContainer.component";
import {WALLET_CARD_IMAGE_PATH, WALLET_MONEY_IMAGE_PATH} from "@/core/CONSTANTS";
import useLocalStorage from "@/core/utils/localStorage";
import {LOGIN_STATE_KEY} from "@/core/services/CONSTANTS";
import {WalletService} from "@/core/tools/wallet/service/wallet.service";
import {Row} from "@/core/general/row.component";
import {Skeleton} from "@mui/material";
import {TextComponent} from "@/core/general/textField.component";
import {blue} from "@mui/material/colors";
import {useTranslations} from "use-intl";
import {toPersianNumber} from "@/core/utils/number.utils";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useDispatch} from "react-redux";
import {AppDispatch} from "@/core/redux/store";
import {loginState} from "@/core/reducer/loginReducer";
import {LOGIN_STATE} from "@/core/reducer/CONSTANTS";
import {useRouter} from "next/navigation";
import {WALLET} from "@/core/navigation/CONSTANTS";

const WalletWidgetComponent: FC<WidgetProps> = (props) => {
  const [isLogin, setLogin] = useLocalStorage<boolean>(LOGIN_STATE_KEY, false);
  const [loading, setLoading] = useState(true);
  const [amountValue, setAmountValue] = useState<string>('');
  const walletService = new WalletService();
  const dispatch = useDispatch<AppDispatch>();
  const t =useTranslations()
  const router = useRouter()

  useEffect(() => {
    if (isLogin) {
      walletService.getWalletAmount().subscribe((data) => {
        if (data && data.data) {
          setLoading(false);
          setAmountValue(data.data[0].balance);
        }
      });
    }
  }, [isLogin]);


  function clickWallet() {
    if(isLogin){
      router.push(WALLET+`?shTitle=${t('financial.wallet')}`);
    }else{
      dispatch(loginState({
        openLoginPage: true,
        state: LOGIN_STATE
      }));
    }
  }

  return (
      <WidgetContainerComponent>
        <div onClick={()=>clickWallet()} className="flex flex-row relative !w-full md:!w-2/3 lg:!w-1/2 overflow-hidden rounded-b-lg totalCenter cursor-pointer">
          <img
              alt={''}
              src={WALLET_CARD_IMAGE_PATH}
              className={'absolute left-0 right-0 top-0 object-cover !h-full'}
              width={'100%'}
              height={'100%'}
          />
          {isLogin ? (
              <Row
                  className={'flex flex-row grow mt-6 mb-6 text-white px-4 z-20 pointer items-center'}
              >
                <img
                    alt={''}
                    src={WALLET_MONEY_IMAGE_PATH}
                    className={'object-cover !w-16 aspect-square me-4 bg-white rounded-full p-1'}
                    width={'100%'}
                    height={'100%'}
                />
                {loading ? (
                    <Skeleton
                        sx={{bgcolor: blue[200]}}
                        className="rounded-md"
                        height="1.5rem"
                        width={'3rem'}
                        variant={'rectangular'}
                    />
                ) : (
                    <TextComponent
                        text={toPersianNumber(Number(amountValue ?? '0').toLocaleString())}
                        isFromTranslate={false}
                        size={'lg'}
                        width={'w-auto'}
                        className={'w-auto text-bold text-center h-8'}
                    />
                )}
                <TextComponent
                    text={t('financial.rial')}
                    isFromTranslate={false}
                    size={'lg'}
                    className={'w-auto mx-2 text-bold text-center h-8'}
                />
              </Row>
          ) : (
              <TextComponent
                  text={'profile.digitalWallet'}
                  className={' mt-6 mb-6 z-20 py-2 px-4 text-white pointer'}
                  isFromTranslate={true}
              />
          )}
          <TextComponent width={"w-auto"}
              text={t('financial.wallet')}
              isFromTranslate={false}
              size={'lg'}
              className={'mx-2 text-bold shrink-0 px-1 text-white text-center h-8 z-20'}
          />
          <ArrowBackIcon style={{ fontSize: '1.5rem' }} className={"text-white z-20 me-2"} />
        </div>
      </WidgetContainerComponent>
);
};

export default React.memo(WalletWidgetComponent);
